import { grey, red } from "@mui/material/colors";

const styles = {
  mainContainer: {
    minHeight: "100%",
    backgroundColor: grey[100],
    padding: "24px",
  },
  secondaryContainer: {
    backgroundColor: 'white', 
    borderRadius: '1rem', 
    width: '100%', 
    padding: '20px', 
    marginBottom: '12px', 
    display: 'flex', 
    gap: '10px'
  },
  activeButton: {
    width: "180px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  inactiveButton: {
    width: "180px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: grey[500],
    color: grey[300],
  }
};

export default styles;
